<template>
  <div>
    <h3 class="text-lg font-[500] mb-4">All Available Routes</h3>
    <div v-loading="loading">
      <div v-for="route in routes" :key="route.id" class="flex gap-3 items-center py-2 my-3">
        <input class="checkbox" type="checkbox" @change="changedValue($event, route)" :checked="value_(route)" />
        <span>{{ route && route.routeName ? route.routeName.replace('-', " to ") : '' }}</span>
      </div>


      <div class="flex justify-end mt-5">
        <base-button text="Next" @click="proceed" :loading="loading" :disabled="disabled" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    this.getRoutes();
    this.resetStateToStore();
  },
  mounted() {
    this.getRoutes();
  },
  computed: {
    disabled() {
      return this.selectedRoute.length < 1
    }
  },
  data() {
    return {
      routes: [],
      selectedRoute: [],
      loading: false
    }
  },
  methods: {
    resetStateToStore() {
      this.selectedRoute = this.$store.getters?.getNewConsolidationSelecetedRoute
    },
    value_(route) {
      return this.selectedRoute.includes(route.id)
    },
    proceed() {
      this.$store.dispatch('setNewConsolidationSelecetedRoutes', this.selectedRoute);
      this.$store.dispatch('setNewConsolidationLevel', 2)
    },
    changedValue(checked, route) {
      checked.target.checked && this.selectedRoute.push(route?.id)
      if (!checked.target.checked) {
        this.selectedRoute = this.selectedRoute.filter((item) => item !== route?.id)
      }
      this.$store.dispatch('setNewConsolidationSelecetedShipment', []);
      this.$store.dispatch('setNewConsolidationSelectedDetailShipment', []);
    },
    async getRoutes() {
      this.loading = true;
      try {
        let response = await this.$_newGetConsolidationRoutes()
        this.routes = response?.data?.data?.routes
      } catch (error) {
        // ...code here
      } finally {
        this.loading = false;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.checkbox {
  width: 1.4rem;
  height: 1.4rem;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-color: #e5e7eb;
  /* gray */
  border: none;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
}

.checkbox:checked {
  background-color: #facc15;
  /* your yellow */
}

.checkbox:checked::after {
  content: "";
  margin-top: -2px;
  width: 0.35rem;
  height: 0.7rem;

  border: solid white;
  border-width: 0 2px 2px 0;

  transform: rotate(45deg);
  display: block;
}
</style>